import React from 'react';
import { useCarousel } from '../common/landingHooks';

const ChevronL = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>;
const ChevronR = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6" /></svg>;

const QUOTES = [
    { q: "We do get quite a lot of blanket emails that aren't really what we're looking for… If someone asks for a recommendation, I'm definitely happy to say, 'Maybe try Diligentsia.' I think that's really helpful.", a: '— GC, Palatine' },
    { q: 'From our perspective, probably the best thing is around the triangulating of applications and the deal sorting.', a: '— FD, Foresight Group' },
    { q: 'Instead of wasting time trying to get the information... you can either pass or play and get to that conclusion far quicker.', a: '— GM' },
];

const GLOWS = [
    { top: '50%', left: -120, size: 400, c: 'rgba(74,103,255,.22)' },
    { top: '50%', right: -120, size: 400, c: 'rgba(252,119,133,.18)' },
];

const pos = (v) => (v == null ? 'auto' : typeof v === 'number' ? v + 'px' : v);

const PEQuotesSection = () => {
    const { viewportRef, trackRef, page, pages, next, prev, goTo, pause, resume } = useCarousel(QUOTES.length, { autoplayMs: 5500 });

    return (
        <section className="lp-quotes">
            <div className="lp-quotes-bg" aria-hidden="true">
                {GLOWS.map((g, i) => (
                    <i key={i} style={{ top: pos(g.top), left: pos(g.left), right: pos(g.right), width: g.size + 'px', height: g.size + 'px', transform: 'translateY(-50%)', background: `radial-gradient(circle, ${g.c}, ${g.c.replace(/[\d.]+\)$/, '0)')} 70%)`, filter: 'blur(78px)' }} />
                ))}
            </div>

            <div className="lp-sec-head">
                <div>
                    <div className="lp-quotes-eyebrow" data-lp-reveal>What they say.</div>
                    <h2 className="lp-h2" data-lp-reveal style={{ maxWidth: '780px', fontSize: '40px' }}>Feedback from PE professionals!</h2>
                    <p className="lp-quotes-sub" data-lp-reveal style={{ maxWidth: '450px' }}>Here's what PE firms and their portfolio companies say about working with Diligentsia.</p>
                </div>
                <div className="lp-arrows">
                    <button className="lp-arrow" aria-label="Previous quotes" onClick={prev}><ChevronL /></button>
                    <button className="lp-arrow" aria-label="Next quotes" onClick={next}><ChevronR /></button>
                </div>
            </div>

            <div className="lp-viewport" onMouseEnter={pause} onMouseLeave={resume}>
                <div className="lp-vp-inner" ref={viewportRef}>
                    <div className="lp-slide-anim">
                        <div className="lp-track" ref={trackRef}>
                            {QUOTES.map((item, i) => (
                                <figure className="lp-qcard" key={i} data-lp-reveal data-lp-delay={(i % 3) * 120}>
                                    <div className="mark">“</div>
                                    <blockquote>“{item.q}”</blockquote>
                                    <figcaption>{item.a}</figcaption>
                                </figure>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            <div className="lp-dots" style={{ justifyContent: 'flex-end' }}>
                {Array.from({ length: pages }).map((_, i) => (
                    <button key={i} className={`lp-dot ${i === page ? 'is-active' : ''}`} aria-label={`Go to slide ${i + 1}`} onClick={() => goTo(i)} />
                ))}
            </div>
        </section>
    );
};

export default PEQuotesSection;
